export default "__VITE_ASSET__6ceef398__"